import axios, { AxiosResponse } from "axios";
import { TestReportGrouping } from "../../models/TestReport";

export const testReportsUrlFor = (report: string) => `/api/v1/testreports/preview?report=${report}`;

/**
 * HEAD request will return the status code, without the payload,
 * we can use it to inspect the status code before trying to show a test
 * report in an iframe (which doesn't allow us to inspect the status)
 * @param service CLE, PDP, POW
 * @param reportType DatabaseReport or TestReport
 */
export const headTestReports = (report: string) => async (): Promise<AxiosResponse> => {
	return await axios.head(testReportsUrlFor(report));
};

/**
 * GETs the test reports grouped by:
 * - service (PDP, POW, CLE)
 * - environment (Live, Staging)
 * - release id
 */
export const getTestReportGroupings = () => async (): Promise<AxiosResponse<TestReportGrouping>> => {
	return await axios.get(`/api/v1/testreports/groupings`);
};
